import { CommonModule } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { RouterLink } from '@angular/router';

@Component({
  selector: 'app-errors',
  standalone: true,
  imports: [CommonModule, RouterLink],
  templateUrl: './errors.component.html',
  styleUrl: './errors.component.css',
})
export class ErrorsComponent {
  constructor() {}

  ngOnInit(): void {}

  errorContent = [
    {
      img: 'assets/img/error.png',
      title: 'Error 404 : Page Not Found',
      paragraph:
        'The page you are looking for might have been removed had its name changed or is temporarily unavailable.',
    },
  ];
}
